import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceManifestJob } from "./parseComplianceManifest";
import { COMPLIANCE_RESULTS_LIST_QUERY_KEY } from "./useComplianceResultsList";
import type { ComplianceManifestJob } from "./types";

export const startComplianceManifest =
  async (): Promise<ComplianceManifestJob | null> => {
    const response = await createRegulatorPortalInstance().post(
      API_ROUTES.REGULATOR_COMPLIANCE_MANIFESTS,
      {},
    );
    return parseComplianceManifestJob(response.data);
  };

export const useStartComplianceManifest = (): UseMutationResult<
  ComplianceManifestJob | null,
  Error,
  void
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "manifest"],
    mutationFn: startComplianceManifest,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: COMPLIANCE_RESULTS_LIST_QUERY_KEY,
      });
    },
  });
};
